import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import { GET_ACHIEVEMENTS_STATS_MESSAGE_TYPE } from '#constants/message-type.constants.ts';
import { GetAchievementStatsResponse } from '#types/response.types.ts';

export const getAchievementsStats = (): Promise<GetAchievementStatsResponse> =>
  SocketAsFetch.fetch({
    message_type: GET_ACHIEVEMENTS_STATS_MESSAGE_TYPE,
  });
